import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { READING_FORMAT_LABELS, READING_FORMAT_EMOJI } from '@/lib/readingFormatUtils';

interface ReadingFormatsChartProps {
  formats: Array<{ format: string; count: number; percentage: number }>;
}

export function ReadingFormatsChart({ formats }: ReadingFormatsChartProps) {
  const getFormatColor = (format: string) => {
    switch (format) {
      case 'print': return 'bg-primary';
      case 'digital': return 'bg-secondary';
      case 'audio': return 'bg-accent';
      default: return 'bg-muted';
    }
  };

  return (
    <Card className="card-elevated">
      <CardHeader>
        <CardTitle>How You Read</CardTitle>
        <p className="text-sm text-muted-foreground">
          Your reading format breakdown
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        {formats.map((item) => (
          <div key={item.format} className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-lg">
                  {READING_FORMAT_EMOJI[item.format as keyof typeof READING_FORMAT_EMOJI] || '📚'}
                </span>
                <span className="font-medium">
                  {READING_FORMAT_LABELS[item.format as keyof typeof READING_FORMAT_LABELS] || 'Other'}
                </span>
              </div>
              <span className="text-muted-foreground">
                {item.count} books ({item.percentage.toFixed(0)}%)
              </span>
            </div>
            <div className="w-full bg-muted/30 rounded-full h-3 overflow-hidden">
              <div
                className={`h-full rounded-full transition-all ${getFormatColor(item.format)}`}
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
